module.exports = new __parcel__URL__("Lightbulb.72a6137f.svg").toString();